import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** One row shared by the mobile nav drawer and the desktop programme rail —
 *  both are "pick a screen / pick a programme" lists using one visual
 *  language. */
export function DrawerItem({
  icon,
  label,
  meta,
  isActive,
  className,
  ...rest
}: {
  icon: ReactNode;
  label: string;
  meta?: string | null;
  isActive?: boolean;
} & ComponentPropsWithoutRef<'button'>) {
  return (
    <button
      type="button"
      className={cn(
        'flex w-full items-center gap-3 rounded-md border-l-2 border-transparent px-2.5 py-2 text-left text-muted-foreground hover:bg-secondary',
        isActive && 'border-brand bg-secondary font-medium text-foreground',
        className,
      )}
      {...rest}
    >
      {icon}
      <span className="flex min-w-0 flex-1 flex-col gap-px">
        <span className="truncate text-[14.5px] font-medium text-foreground">{label}</span>
        {meta != null ? <span className="truncate font-mono text-[11px] text-muted-foreground">{meta}</span> : null}
      </span>
    </button>
  );
}
